export class DriverModel {
  public driverMasterHashId: string;
  public driverName: string;
  public firstName: string;
  public lastName: string;
  public personMasterHashId: string;
  public driverTermId: number;
  public licenceNumber: string;
  public isBanned: boolean;
  public isChecked: boolean;
  public subjectToDirectDebit: boolean;
  public directDebitFileEnabledOnInstance: boolean;
  public ibanNumber: string;
  public bicCode: string;
  public isWeGoAdmin: boolean;
  public isEditable: boolean;
  public isDriverSubsctriptionEnable: boolean;
  public nifNumber: string;
  public isnifEnabled: boolean = false;
  public isDriverLicenseRemove: boolean = false;
  public instanceLanguage: string = 'en';

}

export class DriverBlockModel {
  public driverHashId: string;
  public reason: string;
  public activeFlag: boolean;
}
export class DriverSubscriptionModel {
  public startDatetime: string;
  public endDatetime: string;
  public isActive: boolean;
  public subscriptionaName: string;
  public timeInterval: string;
  public amount: string;
  public freeKilometer: string;
  public freeMinute: string;
  public sharedVehiclegroup: string;
  public isAmountVisible: boolean;
}

export class SVGdriverModel {
  public driverHashId: string;
  public sharedvehiclegroupHashId: string;
  public sharedvehicleGroupSubscriptionHashId: string;
  public organizationSubscriptionHashId: string;
}

export class SharedVehicleGroupDriverModel {
  public sharedvehiclegroupHashId: string;
  public organizationMasterHashId: string;
  public groupName: string;
  public organizationName: string;
  listOfSubscription: SharedVehicleDriverSubscription[];
  public selectedOrganizationSubscription: string;

  constructor() {
  }
}

export class SharedVehicleDriverSubscription {
  public organizationSubscriptionHashId: string;
  public name: string;
}


export class SharedVehicleGroupDriverViewModel {
  public driverHashId: string;
  public sharedVehicleDriverHashId: string;
  public driverName: string;
  public sharedVechicleGroupName: string;
  public organizationName: string;
  public subscriptionName: string
  public firstName: string;
  public lastName: string;
  public endDatetime?: any;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/models/driver.model.ts